export enum LOAD_STATE {
    EMPTY,
    LOADING,
    LOADED,
}
